import React from 'react';
import { Heading, Text } from './Typography';

/**
 * PageHeader — the standard page title block used on every page.
 *
 * Guarantees a uniform title size, subtitle, optional count pill and
 * right-aligned actions, with consistent spacing — so every page's header
 * looks and sits the same.
 *
 *   <PageHeader
 *     title="Clients"
 *     count={42}
 *     subtitle="All clients and their care details."
 *     actions={<Button variant="primary">Add</Button>}
 *   />
 */
const PageHeader = ({ title, count, subtitle, actions }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
    <div className="min-w-0">
      <Heading level={1} className="flex items-center gap-3">
        {title}
        {count != null && (
          <span className="text-[13px] font-bold text-blue-600 bg-[#EEF3FF] dark:bg-blue-900/20 border border-[rgba(37,99,235,0.14)] px-2.5 py-[3px] rounded-full tabular-nums">
            {count}
          </span>
        )}
      </Heading>
      {subtitle && <Text variant="body" as="p" className="mt-1.5">{subtitle}</Text>}
    </div>
    {actions && <div className="flex items-center gap-2.5 flex-wrap shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
